<template>
  <main class="classMain">
    <div>
      <h1>Кнопки текст</h1>
      <ButtonBase size="S" text="Кнопка" />
      <ButtonBase size="M" text="Кнопка" />
      <ButtonBase size="L" text="Кнопка" />
    </div>
    <div>
      <h1>Кнопки текст с иконкой</h1>
      <ButtonBase size="S" text="Кнопка" :icon="baseIcon" />
      <ButtonBase size="M" text="Кнопка" :icon="baseIcon" />
      <ButtonBase size="L" text="Кнопка" :icon="baseIcon" />
    </div>
    <div>
      <h1>Кнопки - стили</h1>
      <div class="blockMargin">
        <GhostButton size="S" text="Кнопка" :icon="baseIcon" />
        <GhostButton size="S" text="Кнопка" :icon="baseIcon" active />
        <GhostButton size="S" text="Кнопка" :icon="baseIcon" disabled />
      </div>
      <div class="blockMargin">
        <SecondaryButton size="S" text="Кнопка" :icon="baseIcon" />
        <SecondaryButton size="S" text="Кнопка" :icon="baseIcon" active />
        <SecondaryButton size="S" text="Кнопка" :icon="baseIcon" disabled />
      </div>
      <div class="blockMargin">
        <PrimaryButton size="S" text="Кнопка" :icon="baseIcon" />
        <PrimaryButton size="S" text="Кнопка" :icon="baseIcon" active />
        <PrimaryButton size="S" text="Кнопка" :icon="baseIcon" disabled />
      </div>
      <div class="blockMargin">
        <GhostButtonError size="S" text="Кнопка" :icon="baseIcon" />
        <GhostButtonError size="S" text="Кнопка" :icon="baseIcon" active />
        <GhostButtonError size="S" text="Кнопка" :icon="baseIcon" disabled />
      </div>
    </div>
    <div>
      <h1>Button.Upload.Image</h1>
      <div class="blockMargin">
        <ButtonUploadImage size="48" />
        <ButtonUploadImage size="48" :image="testImage" />
        <ButtonUploadImage size="48" radius="8" />
        <ButtonUploadImage size="48" :image="testImage" radius="8" />
      </div>
      <div class="blockMargin">
        <ButtonUploadImage size="40" />
        <ButtonUploadImage size="40" :image="testImage" />
        <ButtonUploadImage size="40" radius="8" />
        <ButtonUploadImage size="40" :image="testImage" radius="8" />
      </div>
      <div class="blockMargin">
        <ButtonUploadImage size="28" />
        <ButtonUploadImage size="28" :image="testImage" />
        <ButtonUploadImage size="28" radius="8" />
        <ButtonUploadImage size="28" :image="testImage" radius="8" />
      </div>
    </div>
    <div>
      <h1>Button.Icon</h1>
      <div class="blockMargin">
        <ButtonIcon :icon="baseIcon" />
        <ButtonIcon :icon="baseIcon" variant="ghost" />
      </div>
      <div class="blockMargin">
        <ButtonIcon :icon="baseIcon" size="28" />
        <ButtonIcon :icon="baseIcon" size="28" variant="ghost" />
      </div>
    </div>
    <div>
      <h1>Tabs.User.Avatar</h1>
      <TabUserAvatar text="B" />
    </div>
    <div>
      <h1>Tabs.Panel.Item</h1>
      <div class="blockMargin">
        <TabPanel text="Настройки" />
        <TabPanel text="Настройки" active />
        <TabPanel text="Настройки" disabled />
      </div>
    </div>
    <div>
      <h1>Tabs.Base</h1>
      <div class="blockMargin">
        <TabBase size="S" text="Текст" :icon="baseIcon" />
        <TabBase size="M" text="Текст" :icon="baseIcon" />
        <TabBase size="L" text="Текст" :icon="baseIcon" />
      </div>
    </div>
    <div>
      <h1>Tabs.Style</h1>
      <div class="blockMargin">
        <TabStyle size="M" text="Текст" :icon="baseIcon" variant="subtle" />
        <TabStyle
          size="M"
          text="Текст"
          :icon="baseIcon"
          variant="subtle"
          active
        />
        <TabStyle
          size="M"
          text="Текст"
          :icon="baseIcon"
          variant="subtle"
          disabled
        />
      </div>
      <div class="blockMargin">
        <TabStyle size="M" text="Текст" :icon="baseIcon" variant="ghost" />
        <TabStyle
          size="M"
          text="Текст"
          :icon="baseIcon"
          variant="ghost"
          active
        />
        <TabStyle
          size="M"
          text="Текст"
          :icon="baseIcon"
          variant="ghost"
          disabled
        />
      </div>
      <div class="blockMargin">
        <TabStyle size="M" :icon="baseIcon" variant="ghost" />
        <TabStyle size="M" :icon="baseIcon" variant="ghost" active />
        <TabStyle size="M" :icon="baseIcon" variant="ghost" disabled />
      </div>
      <div class="blockMargin">
        <TabStyle size="M" text="Текст" variant="ghost" />
        <TabStyle size="M" text="Текст" variant="ghost" active />
        <TabStyle size="M" text="Текст" variant="ghost" disabled />
      </div>
    </div>
    <div>
      <h1>Tabs.Complex.Base</h1>
      <div class="blockMargin">
        <TabComplexBase
          size="S"
          text="Текст"
          :actionHandler="() => console.log('hello')"
          @click="() => console.log('helloWorld')"
        />
        <TabComplexBase
          size="M"
          text="Текст"
          :actionHandler="() => console.log('hello')"
          @click="() => console.log('helloWorld')"
        />
      </div>
    </div>
    <div>
      <h1>Tabs.Complex.Base</h1>
      <div class="blockMargin">
        <TabComplexStyle
          size="S"
          text="Текст"
          :actionHandler="() => console.log('hello')"
          @click="() => console.log('helloWorld')"
        />
        <TabComplexStyle
          size="S"
          text="Текст"
          :actionHandler="() => console.log('hello')"
          @click="() => console.log('helloWorld')"
          active
        />
        <TabComplexStyle
          size="S"
          text="Текст"
          :actionHandler="() => console.log('hello')"
          @click="() => console.log('helloWorld')"
          disabled
        />
      </div>
      <div class="blockMargin">
        <TabComplexStyle
          size="M"
          text="Текст"
          :actionHandler="() => console.log('hello')"
          @click="() => console.log('helloWorld')"
        />
        <TabComplexStyle
          size="M"
          text="Текст"
          :actionHandler="() => console.log('hello')"
          @click="() => console.log('helloWorld')"
          active
        />
        <TabComplexStyle
          size="M"
          text="Текст"
          :actionHandler="() => console.log('hello')"
          @click="() => console.log('helloWorld')"
          disabled
        />
      </div>
    </div>
    <div>
      <h1>Tabs.Icon</h1>
      <div class="blockMargin">
        <TabIcon :icon="baseIcon" />
        <TabIcon :icon="baseIcon" active />
        <TabIcon :icon="baseIcon" disabled />
      </div>
      <div class="blockMargin">
        <TabIcon size="28" :icon="baseIcon" />
        <TabIcon size="28" :icon="baseIcon" active />
        <TabIcon size="28" :icon="baseIcon" disabled />
      </div>

      <div class="blockMargin">
        <TabIcon size="24" variant="ghost" :icon="baseIcon" />
        <TabIcon size="24" variant="ghost" :icon="baseIcon" active />
        <TabIcon size="24" variant="ghost" :icon="baseIcon" disabled />
      </div>
      <div class="blockMargin">
        <TabIcon size="28" variant="ghost" :icon="baseIcon" />
        <TabIcon size="28" variant="ghost" :icon="baseIcon" active />
        <TabIcon size="28" variant="ghost" :icon="baseIcon" disabled />
      </div>
    </div>
    <div>
      <h1>List.Dropdown.Button</h1>
      <div class="blockMargin">
        <DropdownButton
          text="Кнопка"
          :icon="baseIcon"
          :index="0"
          :maxSize="3"
          size="S"
        />
        <DropdownButton
          text="Кнопка"
          :icon="baseIcon"
          :index="0"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownButton
          text="Кнопка"
          :icon="baseIcon"
          :index="1"
          :maxSize="3"
          size="S"
        />
        <DropdownButton
          text="Кнопка"
          :icon="baseIcon"
          :index="1"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownButton
          text="Кнопка"
          :icon="baseIcon"
          :index="2"
          :maxSize="3"
          size="S"
        />
        <DropdownButton
          text="Кнопка"
          :icon="baseIcon"
          :index="2"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownButton
          text="Кнопка"
          :icon="baseIcon"
          :index="0"
          :maxSize="1"
          size="S"
        />
        <DropdownButton
          text="Кнопка"
          :icon="baseIcon"
          :index="0"
          :maxSize="1"
          size="M"
        />
      </div>
    </div>
    <div>
      <h1>List.Dropdown.Tab</h1>
      <div class="blockMargin">
        <DropdownTab
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="3"
          size="S"
        />
        <DropdownTab
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownTab
          text="Таб"
          :icon="baseIcon"
          :index="1"
          :maxSize="3"
          size="S"
        />
        <DropdownTab
          text="Таб"
          :icon="baseIcon"
          :index="1"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownTab
          text="Таб"
          :icon="baseIcon"
          :index="2"
          :maxSize="3"
          size="S"
        />
        <DropdownTab
          text="Таб"
          :icon="baseIcon"
          :index="2"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownTab
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="1"
          size="S"
        />
        <DropdownTab
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="1"
          size="M"
        />
      </div>
    </div>
    <div>
      <h1>List.Dropdown.Tab.Complex</h1>
      <div class="blockMargin">
        <DropdownComplex
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="3"
          size="S"
        />
        <DropdownComplex
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownComplex
          text="Таб"
          :icon="baseIcon"
          :index="1"
          :maxSize="3"
          size="S"
        />
        <DropdownComplex
          text="Таб"
          :icon="baseIcon"
          :index="1"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownComplex
          text="Таб"
          :icon="baseIcon"
          :index="2"
          :maxSize="3"
          size="S"
        />
        <DropdownComplex
          text="Таб"
          :icon="baseIcon"
          :index="2"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownComplex
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="1"
          size="S"
        />
        <DropdownComplex
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="1"
          size="M"
        />
      </div>
    </div>
    <div>
      <h1>List.Dropdown.Header</h1>
      <div class="blockMargin">
        <DropdownHeader
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="3"
          size="S"
        />
        <DropdownHeader
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownHeader
          text="Таб"
          :icon="baseIcon"
          :index="1"
          :maxSize="3"
          size="S"
        />
        <DropdownHeader
          text="Таб"
          :icon="baseIcon"
          :index="1"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownHeader
          text="Таб"
          :icon="baseIcon"
          :index="2"
          :maxSize="3"
          size="S"
        />
        <DropdownHeader
          text="Таб"
          :icon="baseIcon"
          :index="2"
          :maxSize="3"
          size="M"
        />
      </div>
      <div class="blockMargin">
        <DropdownHeader
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="1"
          size="S"
        />
        <DropdownHeader
          text="Таб"
          :icon="baseIcon"
          :index="0"
          :maxSize="1"
          size="M"
        />
      </div>
    </div>
    <div>
      <h1>Section.Header.Accordion.Complex</h1>
      <div class="blockMargin">
        <AccordionBase
          showChevronWithActions
          text="Поле №1"
          :defaultOpen="false"
        >
          <template #actions>
            <ButtonIcon :icon="baseIcon" variant="ghost" size="28" />
          </template>
        </AccordionBase>
        <AccordionBase
          showChevronWithActions
          text="Поле №1"
          :defaultOpen="false"
        >
          <template #actions><div /></template>
        </AccordionBase>
      </div>
    </div>
    <div>
      <h1>Section.Header.Accordion</h1>
      <div class="blockMargin">
        <AccordionBase text="Ссылки" />
      </div>
    </div>
    <div>
      <h1>List.Item.NamedValue</h1>
      <div class="blockMargin">
        <InputNamedValue valuePlaceholder="Текст" suffix="₽" />
      </div>
    </div>
    <div>
      <h1>List.Item.Option</h1>
      <div class="blockMargin">
        <CheckboxComponent text="Checkbox" />
        <RadioButton text="Radio" value="fdsfdsfdsf" />
      </div>
    </div>
    <div>
      <h1>Input.Base</h1>
      <div class="blockMargin">
        <InputBase
          description="Комментарий"
          errorText="Текст ошибки"
          positionError="top"
          size="S"
          suffix="Имя"
          isError
        >
          <template #actions>
            <ButtonIcon :icon="baseIcon" variant="ghost" />
          </template>
        </InputBase>
        <InputBase
          description="Комментарий"
          errorText="Текст ошибки"
          positionError="top"
          size="M"
          suffix="Имя"
          isError
        >
          <template #actions>
            <ButtonIcon :icon="baseIcon" variant="ghost" />
          </template>
        </InputBase>
        <InputBase
          description="Комментарий"
          errorText="Текст ошибки"
          positionError="top"
          size="L"
          suffix="Имя"
          isError
        >
          <template #actions>
            <ButtonIcon :icon="baseIcon" variant="ghost" />
          </template>
        </InputBase>
      </div>
    </div>
    <div>
      <h1>Input.Style</h1>
      <div class="blockMargin">
        <InputStyle description="Комментарий" size="M" suffix="Имя">
          <template #actions>
            <ButtonIcon :icon="baseIcon" variant="ghost" />
          </template>
        </InputStyle>
      </div>
      <div class="blockMargin">
        <InputStyle description="Комментарий" size="M" suffix="Имя">
          <template #actions>
            <ButtonIcon :icon="baseIcon" variant="ghost" />
          </template>
        </InputStyle>
      </div>
      <div class="blockMargin">
        <InputStyle
          description="Комментарий"
          size="M"
          suffix="Имя"
          readOnly
          modelValue="fjdsnjfksd"
        >
          <template #actions>
            <ButtonIcon :icon="baseIcon" variant="ghost" />
          </template>
        </InputStyle>
      </div>
      <div class="blockMargin">
        <InputStyle
          description="Комментарий"
          size="M"
          suffix="Имя"
          disabled
          modelValue="fjdsnjfksd"
        >
          <template #actions>
            <ButtonIcon :icon="baseIcon" variant="ghost" />
          </template>
        </InputStyle>
      </div>
      <div class="blockMargin">
        <InputStyle
          description="Комментарий"
          size="M"
          suffix="Имя"
          positionError="bottom"
          errorText="Текст ошибки"
          isError
          modelValue="fjdsnjfksd"
        >
          <template #actions>
            <ButtonIcon :icon="baseIcon" variant="ghost" />
          </template>
        </InputStyle>
      </div>
      <div class="blockMargin">
        <InputStyle
          description="Комментарий"
          size="M"
          textarea
          :minHeightTextArea="100"
        />
      </div>
    </div>
    <div>
      <h1>Input.Select</h1>
      <div class="blockMargin">
        <SelectBase text="Текст" comment="Комментарий" size="S" />
        <SelectBase text="Текст" comment="Комментарий" size="S" disabled />
      </div>
    </div>
    <div>
      <h1>Input.Slider</h1>
      <div class="blockMargin">
        <InputSlider
          suffix="%"
          v-model="testValueSlider"
          size="S"
          text="Комментарий"
        />
        <InputSlider
          suffix="%"
          v-model="testValueSlider"
          size="M"
          text="Комментарий"
        />
        <InputSlider
          suffix="%"
          v-model="testValueSlider"
          size="L"
          text="Комментарий"
        />
      </div>
    </div>
    <div>
      <h1>Input.Switch</h1>
      <div class="blockMargin">
        <SwitchComponent v-model="testSwitch" size="M" />
        <SwitchComponent v-model="testSwitch" size="L" />
      </div>
    </div>
    <div>
      <h1>Input.Radio</h1>
      <div class="blockMargin">
        <RadioButton v-model="testSwitch" value="1" size="M" />
        <RadioButton v-model="testSwitch" value="2" size="L" />
      </div>
    </div>
    <div>
      <h1>Input.Checkbox</h1>
      <div class="blockMargin">
        <CheckboxComponent v-model="testSwitch" value="1" size="M" />
        <CheckboxComponent v-model="testSwitch" value="1" size="L" />
      </div>
    </div>
    <div>
      <h1>Input.Field.Media</h1>
      <div class="blockMargin">
        <InputFieldMedia placeholder="Введите текст" />
        <InputFieldMedia :hasImage="false" placeholder="Введите текст" />
      </div>
    </div>
    <div>
      <h1>Input.File</h1>
      <div class="blockMargin">
        <InputFieldMedia isFile text="Файл" />
        <InputFieldMedia isFile text="Файл" :image="testImage" />
      </div>
    </div>
    <div>
      <h1>Input.Unit</h1>
      <div class="blockMargin">
        <InputUnit>
          <TabStyle text="Px" />
          <TabStyle text="%" active />
        </InputUnit>
      </div>
    </div>
    <div>
      <h1>Input.NamedValue</h1>
      <div class="blockMargin">
        <InputNamedValue
          suffix="₽"
          valuePlaceholder="Текст"
          namePlaceholder="Текст"
        />
      </div>
      <div class="blockMargin">
        <InputNamedValue
          suffix="₽"
          valuePlaceholder="Текст"
          namePlaceholder="Текст"
          name="Текст"
          value="Текст"
        />
      </div>
      <div class="blockMargin">
        <InputNamedValue
          suffix="₽"
          valuePlaceholder="Текст"
          namePlaceholder="Текст"
          disabled
        />
      </div>
      <div class="blockMargin">
        <InputNamedValue
          suffix="₽"
          valuePlaceholder="Текст"
          namePlaceholder="Текст"
          name="Текст"
          value="Текст"
          error
        />
      </div>
    </div>
    <div>
      <h1>Tooltip</h1>
      <div class="blockMargin">
        <TooltipComponent position="top" text="Подсказка">
          <TabStyle :icon="baseIcon" />
        </TooltipComponent>
      </div>
      <div class="blockMargin">
        <TooltipComponent position="right" text="Подсказка">
          <TabStyle :icon="baseIcon" />
        </TooltipComponent>
      </div>
      <div class="blockMargin">
        <TooltipComponent position="bottom" text="Подсказка">
          <TabStyle :icon="baseIcon" />
        </TooltipComponent>
      </div>
      <div class="blockMargin">
        <TooltipComponent position="left" text="Подсказка">
          <TabStyle :icon="baseIcon" />
        </TooltipComponent>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import ButtonBase from "@/elements/UI/button/ButtonBase/ButtonBase.vue";
import baseIcon from "$images/icons/button/Name=Check, Size=16, Tone=Default.svg";
import defaultImage from "$images/google.svg";
import GhostButton from "@/elements/UI/button/ButtonStyle/Default/ghost/GhostButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import GhostButtonError from "@/elements/UI/button/ButtonStyle/Error/ghost/GhostButtonError.vue";
import ButtonUploadImage from "@/elements/UI/button/ButtonUploadImage/ButtonUploadImage.vue";
import ButtonIcon from "@/elements/UI/button/ButtonIcon/ButtonIcon.vue";
import TabUserAvatar from "@/elements/UI/tabs/TabUserAvatar/TabUserAvatar.vue";
import TabPanel from "@/elements/UI/tabs/TabPanel/TabPanel.vue";
import TabBase from "@/elements/UI/tabs/TabBase/TabBase.vue";
import TabStyle from "@/elements/UI/tabs/TabStyle/TabStyle.vue";
import TabComplexBase from "@/elements/UI/tabs/TabComplex/TabComplexBase.vue";
import TabComplexStyle from "@/elements/UI/tabs/TabComplex/TabComplexStyle.vue";
import TabIcon from "@/elements/UI/tabs/TabIcon/TabIcon.vue";
import DropdownButton from "@/elements/UI/list/dropdown/Button/DropdownButton.vue";
import DropdownTab from "@/elements/UI/list/dropdown/Tab/DropdownTab.vue";
import DropdownComplex from "@/elements/UI/list/dropdown/Complex/DropdownComplex.vue";
import DropdownHeader from "@/elements/UI/list/dropdown/Header/DropdownHeader.vue";
import AccordionBase from "@/elements/UI/accordion/AccordionBase.vue";
import InputNamedValue from "@/elements/UI/input/NamedValue/InputNamedValue.vue";
import CheckboxComponent from "@/elements/UI/input/Checkbox/CheckboxComponent.vue";
import RadioButton from "@/elements/UI/input/Radio/RadioButton.vue";
import InputBase from "@/elements/UI/input/Base/InputBase.vue";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";
import SelectBase from "@/elements/UI/select/SelectBase.vue";
import InputSlider from "@/elements/UI/input/Slider/InputSlider.vue";
import SwitchComponent from "@/elements/UI/input/Switch/SwitchComponent.vue";
import InputFieldMedia from "@/elements/UI/input/Media/InputFieldMedia.vue";
import InputUnit from "@/elements/UI/input/Unit/InputUnit.vue";
import TooltipComponent from "@/elements/UI/overlay/Tooltip/TooltipComponent.vue";

export default defineComponent({
  name: "EnvyWidget",
  components: {
    TooltipComponent,
    InputUnit,
    InputFieldMedia,
    SwitchComponent,
    InputSlider,
    SelectBase,
    InputStyle,
    InputBase,
    RadioButton,
    CheckboxComponent,
    InputNamedValue,
    AccordionBase,
    DropdownHeader,
    DropdownComplex,
    DropdownTab,
    DropdownButton,
    TabIcon,
    TabComplexStyle,
    TabComplexBase,
    TabStyle,
    TabBase,
    TabPanel,
    TabUserAvatar,
    ButtonIcon,
    ButtonUploadImage,
    GhostButtonError,
    PrimaryButton,
    SecondaryButton,
    GhostButton,
    ButtonBase
  },

  data() {
    return {
      baseIcon,
      testImage: `url(${defaultImage})`,
      testValueSlider: 50,
      testSwitch: false
    };
  },

  methods: {}
});
</script>

<style scoped>
.classMain {
  padding: 100px;
}

.blockMargin {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}
</style>
